"use client";

import type { AuthWebappPermissionAtom } from "@/gen/orval/webplatform/model/authWebappPermissionAtom.gen";

import { useJwt } from "@/subsystems/access/json-web-token/hooks/use-jwt";
import { hasAllPermissions } from "@/subsystems/access/permissions/has-all-permissions";

/**
 * Returns whether the current user has all of the given permission atoms.
 * AND semantics: passing an array requires every atom to be granted.
 *
 * See `useUserCanAny` for OR semantics (used by routes shared between role
 * surfaces, e.g. /a/c/instant-liquidity).
 *
 * The backend is the security boundary; this hook is UX only.
 */
export function useUserCan(permission: AuthWebappPermissionAtom | readonly AuthWebappPermissionAtom[]): boolean {
  const claims = useJwt();

  const required = Array.isArray(permission) ? permission : [permission];
  const granted = claims?.permissions ?? [];
  return hasAllPermissions(granted, required);
}
